import React from 'react';
interface ToggleProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  helperText?: string;
  disabled?: boolean;
}
export function Toggle({
  label,
  checked,
  onChange,
  helperText,
  disabled = false
}: ToggleProps) {
  return <div className="flex flex-col" data-id="element-1247">
      <div className="flex items-center justify-between" data-id="element-1248">
        {label && <span className="text-sm font-medium text-gray-700 mr-3" data-id="element-1249">
            {label}
          </span>}
        <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => !disabled && onChange(!checked)} className={`
            relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2
            ${checked ? 'bg-blue-600' : 'bg-gray-200'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `} data-id="element-1250">
          <span aria-hidden="true" className={`
              pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
              ${checked ? 'translate-x-5' : 'translate-x-0'}
            `} data-id="element-1251" />
        </button>
      </div>
      {helperText && <p className="mt-1 text-xs text-gray-500" data-id="element-1252">{helperText}</p>}
    </div>;
}